import { Box } from "@mui/material";
import ColorfulRole from "../UIToolkit/ColorfulRole/ColorfulRole";

interface IProps {
	roles: string[];
}

export const NurseRoleList = ({ roles }: IProps) => {
	return (
		<Box>
			{roles.map((role: string) => (
				<ColorfulRole key={role} role={role} />
			))}
		</Box>
	);
};
